import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricBeat extends MetricBase {
    constructor() {
        super({
            field: "metric_beat_ratio",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.trivago.beat.chartName"),
            serieLabel: i18n.t("metrics.trivago.beat.serieLabel"),
            tooltip: i18n.t("metrics.trivago.beat.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricBeat;
